import React, { useRef, useEffect, useState } from "react";

export default function Section({ id, title, content }) {
  const ref = React.useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id={id}
      ref={ref}
      className={`section ${visible ? "fade-in" : "fade-out"}`}
      style={{ padding: "1rem 0" }}
    >
      <h2>{title}</h2>
      <p>{content}</p>

    </section>
  );
}
